{
  "id": 12,
  "documentId": "yg5j4hldqc3pexig1moic92t",
  "site": {
    "name": "Baharudin Yusup",
    "url": "https://www.baharudin.dev",
    "metaTitle": "Baharudin Yusup - Senior Mobile Engineer & Technical Lead",
    "metaDescription": "Senior Mobile Engineer and Technical Lead with 8+ years building apps used by millions, including Avis & Budget (car-rental giant, 15M+ users), UOB (one of Singapore's largest banks), Scoot (regional airline), and BRI (Indonesia's largest state-owned bank). Ships production apps across the full mobile spectrum: native Android, iOS, Flutter, and React Native."
  },
  "nav": {
    "about": "About",
    "experience": "Experience",
    "projects": "Projects",
    "education": "Education",
    "certifications": "Certifications",
    "awards": "Awards"
  },
  "chrome": {
    "brand": "Portfolio",
    "madeBy": "Made by",
    "onThisPage": "On This Page",
    "quickContact": "Quick Contact",
    "getInTouch": "Get in Touch"
  },
  "pages": {
    "about": {
      "title": "Baharudin Yusup",
      "subtitle": "Welcome to my portfolio",
      "metaTitle": "About - Baharudin Yusup",
      "empty": {
        "title": "No profile yet",
        "message": "Profile information will appear here when available."
      },
      "viewExperienceCta": "View Experience",
      "exploreProjectsCta": "Explore Projects",
      "expertiseHeading": "Technical Expertise",
      "contactHeading": "Get In Touch"
    },
    "experience": {
      "title": "Work Experience",
      "subtitle": "8+ years of professional experience in mobile and full-stack development",
      "metaTitle": "Work Experience - Baharudin Yusup",
      "empty": {
        "title": "No experience yet",
        "message": "Experience information will appear here when available."
      }
    },
    "projects": {
      "title": "Projects",
      "subtitle": "Projects and applications I've built",
      "metaTitle": "Projects - Baharudin Yusup",
      "empty": {
        "title": "No projects yet",
        "message": "Project information will appear here when available."
      },
      "githubCta": "Explore My GitHub",
      "collaboration": {
        "heading": "Interested in collaborating?",
        "body": "I'm always open to discussing new opportunities and innovative projects.",
        "contactCta": "Get in Touch",
        "githubCta": "View My GitHub"
      }
    },
    "education": {
      "title": "Education",
      "subtitle": "Academic background and formal education",
      "metaTitle": "Education - Baharudin Yusup",
      "empty": {
        "title": "No education yet",
        "message": "Education information will appear here when available."
      },
      "focusAreasHeading": "Key Focus Areas",
      "focusAreas": [
        {
          "title": "Computer Engineering",
          "body": "Specialized in computer systems design, software engineering principles, and hardware-software integration. Gained comprehensive understanding of both theoretical foundations and practical applications."
        },
        {
          "title": "Software Development",
          "body": "Extensive coursework in programming languages, data structures, algorithms, and software engineering methodologies. Developed strong problem-solving skills and coding proficiency."
        },
        {
          "title": "System Architecture",
          "body": "Studied computer architecture, operating systems, and distributed systems. Understanding of how software and hardware components work together to create efficient computing solutions."
        }
      ],
      "philosophyHeading": "Learning Philosophy",
      "philosophy": [
        {
          "title": "Continuous Learning",
          "body": "Technology evolves rapidly, and I believe in staying current with the latest developments. I regularly engage with online courses, technical documentation, and hands-on projects to expand my knowledge and skills."
        },
        {
          "title": "Practical Application",
          "body": "I learn best by doing. Every concept I study is immediately applied through personal projects, contributing to open source, or solving real-world problems. This approach helps solidify understanding and builds practical experience."
        }
      ]
    },
    "certifications": {
      "title": "Certifications",
      "subtitle": "Professional certifications and technical qualifications",
      "metaTitle": "Certifications - Baharudin Yusup",
      "empty": {
        "title": "No certifications yet",
        "message": "Certification information will appear here when available."
      },
      "overviewHeading": "Certification Overview",
      "stats": {
        "total": {
          "label": "Total Certifications",
          "caption": "Professional and technical qualifications"
        },
        "expert": {
          "label": "Expert Level",
          "caption": "Advanced proficiency certifications"
        },
        "active": {
          "label": "Active Certifications",
          "caption": "Currently valid qualifications"
        }
      },
      "essay": [
        "These certifications represent my commitment to continuous learning and professional development in the technology industry. Each certification validates specific skills and knowledge areas, demonstrating expertise across multiple domains including mobile development, cloud computing, and software engineering.",
        "The certifications are obtained from reputable organizations and platforms, ensuring they meet industry standards and are recognized by employers worldwide. They complement my practical experience and provide a structured framework for skill validation and career advancement.",
        "Maintaining these certifications requires ongoing education and staying current with industry best practices, which aligns with my approach to continuous improvement and staying at the forefront of technology trends."
      ]
    },
    "awards": {
      "title": "Awards & Recognition",
      "subtitle": "Achievements and recognition in entrepreneurship and innovation",
      "metaTitle": "Awards & Recognition - Baharudin Yusup",
      "empty": {
        "title": "No awards yet",
        "message": "Awards information will appear here when available."
      },
      "journeyHeading": "Entrepreneurship Journey",
      "stats": {
        "awards": {
          "label": "Major Awards",
          "caption": "Recognition across multiple startup competitions"
        },
        "years": {
          "value": "3",
          "label": "Years",
          "caption": "Consistent recognition from 2020-2021"
        },
        "place": {
          "value": "1st",
          "label": "Place",
          "caption": "Winner in Trade and Services category"
        }
      },
      "narrative": [
        "My entrepreneurship journey began during university, where I founded PT Venragroup Teknologi Indonesia in 2018. The startup focused on innovative technology solutions and quickly gained recognition in the Indonesian startup ecosystem.",
        "Through consistent innovation and market-focused solutions, the company achieved remarkable growth, increasing revenue by 15% quarter-over-quarter. The recognition from various startup competitions validated our approach to solving real-world problems through technology.",
        "These achievements demonstrate not just technical skills, but also business acumen, leadership capabilities, and the ability to turn ideas into successful ventures. The experience gained from building and scaling a startup continues to inform my approach to software development and technical leadership."
      ]
    }
  },
  "cards": {
    "summary": "Summary",
    "description": "Description",
    "keyAchievements": "Key Achievements",
    "keyProjects": "Key Projects",
    "featured": "Featured",
    "team": "Team",
    "duration": "Duration",
    "achievements": "Achievements",
    "challenges": "Challenges",
    "learnings": "Learnings",
    "viewCode": "View Code",
    "liveDemo": "Live Demo",
    "documents": "Documents",
    "diploma": "Diploma",
    "transcript": "Transcript",
    "relatedLinks": "Related Links",
    "level": "Level",
    "id": "ID",
    "expires": "Expires",
    "issuedBy": "Issued by",
    "view": "View",
    "download": "Download"
  },
  "resume": {
    "cardTitle": "Get my resume",
    "cardBody": "I'll send you a detailed PDF version of my professional experience and skills.",
    "trigger": "Get Resume",
    "dialogTitle": "Get my resume",
    "dialogBody": "Please fill in the form below so I can send you a detailed PDF version of my professional experience and skills.",
    "successMessage": "Perfect! I'll send my resume to your email right away.",
    "errorMessage": "Something went wrong. Please check your details and try again.",
    "form": {
      "personalLegend": "Personal Information",
      "nameLabel": "Full Name",
      "namePlaceholder": "Enter your full name",
      "emailLabel": "Email Address",
      "emailPlaceholder": "Enter your email address",
      "companyLabel": "Company (Optional)",
      "companyPlaceholder": "Company name",
      "positionLabel": "Position (Optional)",
      "positionPlaceholder": "Job title or position",
      "messageLegend": "Message",
      "messageLabel": "If you have any specific requirements or additional message, please let me know.",
      "messagePlaceholder": "Enter your message here (optional)",
      "cancel": "Cancel",
      "submit": "Send Resume"
    }
  },
  "system": {
    "errorTitle": "Oops, something went wrong",
    "errorBody": "Please try again later or contact me if the problem persists.",
    "retry": "Try Again",
    "notFoundTitle": "404 - Page not found",
    "notFoundBody": "The page you are looking for does not exist or has been moved.",
    "backHome": "Back to home",
    "routeErrorTitle": "Something went wrong",
    "routeErrorBody": "An unexpected error occurred while rendering this page. Reloading usually fixes it.",
    "reload": "Reload Page",
    "skipToContent": "Skip to content"
  },
  "createdAt": "2026-08-13T17:49:20.311Z",
  "updatedAt": "2026-08-14T09:31:32.803Z",
  "publishedAt": "2026-08-14T09:31:32.799Z",
  "locale": "en",
  "localizations": []
}
